import React from "react";
import { useFlags } from "flagsmith/react";
import { ConfirmNamesV1 } from "./ConfirmNamesV1";
import { ConfirmNamesV2 } from "./ConfirmNamesV2";
import { useAuthToken } from "hooks/useAuthToken";
import { FeatureFlags } from "fixtures/features";

const ConfirmNamesTaskView: React.FC = () => {
  const proposalToken = useAuthToken("PROPOSAL")?.token;
  const isCustomer = !!proposalToken;
  const flags = useFlags([FeatureFlags.CHECKOUT_SRA]);
  const isCheckoutSraEnabled =
    flags[FeatureFlags.CHECKOUT_SRA]?.enabled ?? false;

  const showV2 = !isCustomer && isCheckoutSraEnabled;

  return showV2 ? <ConfirmNamesV2 /> : <ConfirmNamesV1 />;
};

export { ConfirmNamesTaskView };
